import React, { useState } from 'react';
import Box from 'v2/components/UI/Box';
import ButtonBase from 'v2/components/UI/ButtonBase';

interface IMenuButton {
  open: boolean;
  handleClick: () => void;
}
const Line: React.FC<{
  open: boolean;
  y?: number;
  width: number;
  deg?: number;
  opacity?: boolean;
}> = ({ open, y, width, opacity, deg }) => {
  return (
    <Box
      width={width}
      height={3}
      borderRadius={12}
      background={open ? '#5f1300' : '#005f47'}
      transition="0.4s"
      transform={
        open ? `rotate(${deg ?? -45}deg) translateY(${y ?? -2}px)` : 'none'
      }
      opacity={open && opacity ? 0 : 1}
    />
  );
};
const MenuButton: React.FC<IMenuButton> = ({ handleClick, open }) => {
  return (
    <ButtonBase
      display="flex"
      flexDirection="column"
      justifyContent={open ? 'center' : 'space-between'}
      alignItems={open ? 'center' : 'flex-end'}
      height={50}
      width={50}
      borderRadius={12}
      transform={open ? 'rotate(90deg)' : 'none'}
      background={open ? '#ff33003c' : '#b7ffbd80'}
      onClick={handleClick}
      gap={open ? 0 : 5}
      padding={14}
    >
      <Line open={open} width={24} y={2} />
      <Line open={open} width={16} opacity />
      <Line open={open} width={24} deg={45} />
    </ButtonBase>
  );
};

export default MenuButton;
